<template>
    <b-container fluid class="mx-3 form-control form-sample">
        <b-modal v-model="isVisible" hide-footer class="pt-8" header-class="p-0" content-class="custom-model-wrap">
            <template #modal-title="{ cancel }">
                <div class="title-block text-center p-2">{{ $translate('uploaded_file') }}</div>
                <div class="close-btn" @click="cancel()">×</div>
            </template>
            <b-img :src="model && model.url" v-if="['jpg', 'jpeg', 'png'].includes(model && model.file_extension)" fluid
                alt="Responsive image"></b-img>
            <a v-else-if="['xls', 'xlsx'].includes(
                model && model.file_extension
            )
                " :href="model && model.url">
                <div class="btn btn-success btn-sm">
                    <i class="fa-solid fa-file-excel fa-2x"></i>
                </div>
            </a>
            <video v-else-if="['mp4'].includes(
                model && model.file_extension
            )
                " width="50%" height="50%" controls>
                <source :src="model.url" type="video/mp4">
            </video>
            <a v-else-if="model && model.file_extension == 'pdf'" :href="model && model.url">
                <div class="btn delete-button btn-sm">
                    <i class="fa-solid fa-file-pdf fa-2x"></i>
                </div>
            </a>
            <a v-else :href="model && model.url">
                <div class="btn btn-success btn-sm">
                    <i class="fa-solid fa-file fa-2x"></i>
                </div>
            </a>
            <br />
         
            <div class="row px-3" >
                <b-list-group class="mt-2 col-12 col-sm-9">
                    <b-list-group-item class="d-inline-flex p-2">
                        <!--file name input to rename the file before upload-->
                        <b-form-input :placeholder="$translate('file_name_placeholder')" v-model="model.name" required
                            v-custom-validation="$textRequired()" />
                        <!--file extension-->
                        <span class="d-inline-flex align-items-center text-muted ml-1 mr-3">.{{ model.file_extension
                        }}</span>
                        <b-form-textarea placeholder="Description"  v-model="model.description"
                        ref="inputField"  ></b-form-textarea>
                    </b-list-group-item>
                </b-list-group>
                <b-col cols="12" sm="3" class="align-self-center pt-2">
                    <b-button type="submit" id="rename-file" variant="info" class="btn-fw" @click="renameFileName(model.index, model.name,model.description)">
                        {{ $translate('update') }}
                    </b-button>
                </b-col>
            </div>
            <div v-if="!model.order_id">
                <b-button variant="info" id="delete-file" size="fw" class="mt-2" @click="deleteImage(model.index)">{{ $deleteLabel()
                }}</b-button>
            </div>
        </b-modal>
        <b-row v-if="attachments.length" class="attachment">
            <b-col v-for="(item, idx) in attachments.slice(0, 4)" :key="`item${idx}`" cols="3" md="2">
                <button type="button" class="test-image-btn" :id="'image-btn-'+idx" v-if="['jpg', 'jpeg', 'png'].includes(
                    item.file_extension
                )
                    " @click="setModel(item, idx)">
                    <b-img :height="itemHeight" :width="itemWidth" :src="item.url" alt="item 1"></b-img>
                </button>
                <button type="button" class="test-excel-btn" :id="'excel-btn-'+idx" v-else-if="['xls', 'xlsx'].includes(
                    item.file_extension
                )
                    " @click="setModel(item, idx)">
                    <div class="btn btn-success btn-sm">
                        <i class="fa-solid fa-file-excel fa-2x"></i>
                    </div>
                </button>
                <button type="button" class="test-audio-btn" :id="'audio-btn-'+idx" v-else-if="['mp4'].includes(
                    item.file_extension
                )
                    " @click="setModel(item, idx)">
                    <div class="btn btn-dark btn-sm">
                        <i class="fa-solid fa-play"></i>
                    </div>
                </button>
                <button type="button" class="test-pdf-btn" :id="'pdf-btn-'+idx" v-else-if="item.file_extension == 'pdf'" @click="setModel(item, idx)">
                    <div class="btn delete-button btn-sm">
                        <i class="fa-solid fa-file-pdf fa-2x"></i>
                    </div>
                </button>
                <button type="button" class="test-file-btn" :id="'file-btn-'+idx" v-else @click="setModel(item, idx)">
                    <div class="btn btn-success btn-sm">
                        <i class="fa-solid fa-file fa-2x"></i>
                    </div>
                </button>
                <div>
                    <label>{{ item.name ? item.name + '.' + item.file_extension : '' }}</label><br>
                    <div class="mt-1 mb-2" v-if="item.updated_at">
                        <label><b>{{ $translate('upload_on') }}</b></label><br>
                        <label>{{ item.created_at | displayTime }}</label>
                    </div>
                </div>
            </b-col>

        </b-row>
        <b-row v-else>
            <b-col>{{ $translate('no_attachments_submitted') }}</b-col>
        </b-row>
    </b-container>
</template>

<script>
import locationMixins from '@/mixins/locationMixins'
import popupMixins from '@/mixins/popupMixins'

export default {
    mixins: [locationMixins, popupMixins],
    props: { attachments: Array, value: Boolean },
    data() {
        return {
            isVisible: false,
            model: {
                order_id: null,
                description:null,
            },
            itemHeight: 60,
            itemWidth: 60,
        }
    },
    watch: {
        value: function (val) {
            this.isVisible = val
        },
        isVisible: function (val) {
            this.$emit('input', val)
        },
    },
    mounted() {
        setTimeout(() => {
            this.$store.dispatch('js_report/fetchCredentials')
        }, 500)
    },
    filters: {
        displayTime(date) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
            console.log('timezone', timezone)
            if (date) {
                return new Date(date).toLocaleString('en-US', {
                    timeZone: timezone,
                })
            } else {
                return ''
            }
        },

    },
    computed:{
        mediaBaseUrl() {
            return this.$store.getters['mediaBaseUrl']
        },
    },
    methods: {
        renameFileName(fileIndex, newName,newDescription) {
            const file = this.attachments[fileIndex]
            if (!newName) {
                this.doToast(this.$translate('error'), this.$translate('file_name_required'), 'danger')
                return false
            }
            file.name = newName
            file.description = newDescription
            this.attachments[fileIndex] = file
            this.$store.commit('orderAttachmentsStore/SET_CHANGED', true)
            this.updateAttachment(this.attachments)
            this.isVisible = false
        },
        async updateAttachment(newFiles) {
            this.$store.dispatch('customerPortal/merge', {
                newFiles,
            })
        },
        setModel(item, i) {
            this.model = { ...item, index: i }
            for (const key in item) {
                this.$set(this.model, key, item[key])
            }
            this.isVisible = true
        },
        deleteImage(idx) {
            this.attachments.splice(idx, 1)
            this.$emit('update-attachments', [...this.attachments])
            this.isVisible = false
        },
        async uploadFile(event) {
            const $this = this
            try {
                const p = await this.getCurrentLocation()
                console.log('coordinates', p)
                const lat = p.coords.latitude
                const long = p.coords.longitude

                console.log("filesssss", event.target.files)
                const { key, name } = await $this.$store.dispatch(
                    's3files/s3upload',
                    event.target.files
                )
                const file_extension = event.target.files[0].name.split('.').pop()


                const url = `${$this.mediaBaseUrl}/${key}`
                console.log("abcccc", { key, name, url })
                $this.attachments.push({ url, lat, file_extension, long })
                $this.$emit('update-attachments', [...$this.attachments])
            } catch (err) {
                this.doToast(
                    this.$translate('error'),
                    err.message,
                    'danger'
                )
            }
        },
    },
}
</script>
